import onChange from 'on-change';

export default (state, view) =>
	onChange(state, (path, value) => {
		switch (path) {
			case 'isOpened':
				view.toggleContentVisibility(value);
				break;
			default:
				throw new Error(`unknown mutation - ${path}: ${value}`);
		}
	});
